import * as React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import QuestionMark from "@mui/icons-material/QuestionMark";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CancelIcon from "@mui/icons-material/Cancel";
import { useState, useEffect } from "react";

function BAVToggleButton(props) {
  const buttonIcons = [
    <QuestionMark />,
    <CheckBoxIcon color="success" />,
  ];
  const [buttonState, setButtonState] = useState(0);
  const [buttonIcon, setButtonIcon] = useState(buttonIcons[0]);
  const maxState = 1;
  function initButtonValue() {
    var varname = "value_" + props.button;
    var varvalue = props[varname] || 0;
    var newState = varvalue > 1 ? 0 : varvalue;
    var newIcon = buttonIcons[newState];
    setButtonIcon(newIcon);
    setButtonState(newState);
  }
  function changeState(event) {
    var newState;
    var newIcon;
    if (event.refresh == 1) {
      var varname = "value_" + props.button;
      var varvalue = props[varname] || 0;
      // Wenn value_3 auf 1 steht, darf value_1 nicht auf 0 gehen
      if (props["button"] == 1 && props["value_3"] == 1) {
          varvalue = 1;
      }
      newState = varvalue;
      newIcon = buttonIcons[varvalue];
    } else {
      if (buttonState >= maxState ) {
          // Änderung nur zulassen, wenn "Aufklärung erhalten" nicht gesetzt
          if (props["button"] == 1 && props["value_3"] == "1") {
              newState = 1;
              newIcon = buttonIcons[1];
          } else {
              newState = 0;
              newIcon = buttonIcons[0];
          }
      } else {
        var newState = parseInt(buttonState) + 1;
        newIcon = buttonIcons[newState];
      }
    }
    setButtonIcon(newIcon);
    setButtonState(newState);
    if (typeof props.callback == "function") {
      props.callback(props, newState);
    }
  }
  useEffect(() => {
    initButtonValue();
  }, [props.value_1, props.value_2, props.value_3]);

  if (props.readOnly) {
        return (
            <>
                <ToggleButton
                    value="bold"
                    aria-label="bold"
                    size="small"
                    disabled={true}
                >
                    {buttonIcon}
                </ToggleButton>
            </>
        );
    } else {
        return (
            <>
                <ToggleButton
                    value="bold"
                    aria-label="bold"
                    size="small"
                    onClick={changeState}
                >
                    {buttonIcon}
                </ToggleButton>
            </>
        );
    }
}
export default BAVToggleButton;
